import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Field, Page } from "@/components/Layout";

export const Inviata = ({ email }) => (
  <div className="card text-center py-12" data-testid="register-success">
    <MailCheck size={48} className="mx-auto text-[#7E5BAF]" />
    <h2 className="font-display text-3xl mt-4">Controlla la tua email</h2>
    <p className="text-[#786E65] mt-2">Abbiamo inviato un link di conferma a <strong>{email}</strong>. Dopo la conferma potrai accedere.</p>
    <Link to="/accedi" className="btn-secondary mt-6">Vai all'accesso</Link>
  </div>
);

export default function Registrati() {
  const [f, setF] = useState({ nome: "", email: "", password: "" });
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    try {
      await api.post("/auth/registrati", f);
      setOk(true);
    } catch (e2) {
      setErr(errMsg(e2));
    }
  };
  return (
    <Page className="max-w-md">
      <h1 className="font-display text-4xl sm:text-5xl">Crea il tuo account</h1>
      <p className="text-[#786E65] mt-2">Facoltativo: ti serve solo per ritrovare le gift card acquistate e ricevute.</p>
      {ok ? <div className="mt-8"><Inviata email={f.email} /></div> : (
        <form onSubmit={submit} className="card mt-8 space-y-5" data-testid="register-form">
          <Field label="Nome"><input required className="field" value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} data-testid="reg-nome-input" /></Field>
          <Field label="Email"><input required type="email" className="field" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="reg-email-input" /></Field>
          <Field label="Password" hint="Almeno 8 caratteri"><input required minLength={8} type="password" className="field" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="reg-password-input" /></Field>
          {err && <p className="text-sm text-red-700" data-testid="register-error">{err}</p>}
          <button className="btn-primary w-full" data-testid="register-submit-btn">Registrati</button>
        </form>
      )}
    </Page>
  );
}
